<template>
    <div>

        <p>
            <strong>Association avec la carte <i><a v-bind:href="'https://trello.com/c/' + card.id" target="_blank">{{card.name}}</a></i></strong>
        </p>

        <p>
            <button
                    class="btn btn-primary"
                    v-on:click="associateProcess"
                    v-bind:disabled="associationEnCours || card.id === ''"
            >Associer</button>
        </p>

        <b-alert v-if="associationOk" variant="success" show>
            <span class="alert">Association réussie !</span>
            <router-link :to="{ name: 'Edit', params: {id: subjectId} }">Editer cette carte</router-link>
        </b-alert>

        <b-alert v-if="!associationOk && bddError" variant="danger" show>
            Erreur durant la création du sujet ! Réessayer.<br>
            <i>Attention une carte ne peut être associée qu'à un seul sujet.</i>
        </b-alert>

        <b-alert v-if="!associationOk && associationError" variant="danger" show>
            Sujet créé mais échec association Trello.
            <strong v-on:click="associateCard" style="text-decoration: underline; cursor: pointer;">Cliquez ici pour
                réessayer.</strong>
        </b-alert>

    </div>
</template>

<script>

  import bdd from '../../api/bdd'

  export default {

    name: 'ValidateAssociation',

    data() {
      return {
        message: '',
        subjectId: '',
        associationOk: false,
        bddError: false,
        associationError: false,
        associationEnCours: false
      }
    },

    props: ['card'],

    methods: {

      associateProcess: function (e) {
        e.preventDefault()
        this.associationOk = false
        this.associationEnCours = true
        if (this.card.id !== '') {
          bdd.createSubject(this.card.id, this.card.name, this.card.desc)
            .then(response => {
              this.subjectId = response.data.id
              this.associateCard()
            })
            .catch(error => {
              this.bddError = true
              this.associationEnCours = false
              console.log('Erreur bdd !')
              console.log(error)
            })
        } else {
          this.message = 'Aucune carte sélectionnée !'
        }
      },

      associateCard: function () {
        this.associationOk = false
        let cardEditLink = process.env.CLIENT_URL + '/#/edit/' + this.subjectId
        let params = {
          desc: '### Lien pour éditer cette carte : \x0A [' + cardEditLink + '](' + cardEditLink + ') \x0A \x0A --- \x0A ' + this.card.desc
        }
        window.Trello.put('cards/' + this.card.id, params, this.associateSuccess, this.associateError)
      },

      associateSuccess: function () {
        this.associationOk = true
        this.associationEnCours = false
        console.log('association réussie !')
      },

      associateError: function (e) {
        this.associationError = true
        console.log('Erreur durant l\'association !')
        console.log(e)
      }

    }

  }

</script>



// WEBPACK FOOTER //
// src/components/AssociateSub/ValidateAssociation.vue